import React, { Component } from 'react'
import { FireBackground } from 'app/common/background'
import { ErrorManagement } from 'app/common/error-management'
import { Layout } from 'app/common/layout'
import type { MenuListItem } from 'app/common/layout/menu'
import { MenuLayout } from 'app/common/layout/menu'
import { OrdersList } from 'app/ecommerce/common'
import { Challenges } from 'app/kingdom/challenges'
import type { IntlShape } from 'react-intl'
import { injectIntl } from 'react-intl'
import { Redirect } from 'react-router-dom'
import { Card } from './card'
import { Dashboard } from './dashboard'
import { kingdomItems } from './kingdomItems'
import { Profile } from './profile'
import { CATEGORY_ID, featureCodes } from 'shared/utils'

type Props = {
    error: any,
    networkError: any,
    match: any,
    intl: IntlShape,
    availableFeatures: string[],
    isActiveZendesk: boolean
}

type State = {
    menuItems: Array<MenuListItem>
}

class Kingdom extends Component<Props, State> {
    constructor(props: Props) {
        super(props)
        const { intl, availableFeatures } = props

        const blazonsIsAvailable = availableFeatures.includes(
            featureCodes.KINGDOM_MENU_BLAZON
        )

        const menuItems = kingdomItems.map((item: MenuListItem) => {
            return {
                ...item,
                title: intl.formatMessage({ id: item.title }),
                tileText: item.tileText
                    ? intl.formatMessage({ id: item.tileText })
                    : undefined,
                routeId: item.routeId
                    ? intl.formatMessage({ id: item.routeId })
                    : undefined,
                inMenu:
                    item.categoryId === CATEGORY_ID.BLAZON
                        ? blazonsIsAvailable
                        : item.inMenu,
                inMenuMobile:
                    item.categoryId === CATEGORY_ID.BLAZON
                        ? blazonsIsAvailable
                        : item.inMenuMobile
            }
        })
        this.state = {
            menuItems
        }
    }

    getChildElement = (kingdomId: string) => {
        const { intl, isActiveZendesk } = this.props
        const { menuItems } = this.state
        const card = intl.formatMessage({ id: 'routes.kingdom.card' })
        const information = intl.formatMessage({
            id: 'routes.kingdom.information'
        })
        const orders = intl.formatMessage({ id: 'routes.kingdom.orders' })
        const blazons = intl.formatMessage({ id: 'routes.kingdom.challenges' })
        const faq = intl.formatMessage({ id: 'routes.question' })
        switch (kingdomId) {
            case undefined:
                return <Dashboard kingdomItems={menuItems} />
            case card:
                return <Card />
            case information:
                return <Profile />
            case orders:
                return <OrdersList />
            case blazons:
                return <Challenges />
            case faq:
                if (!!isActiveZendesk) {
                    window.history.replaceState(null, '', '/')
                    window.location.href = process.env.REACT_APP_ZENDESK_URL
                    return null
                } else {
                    return <Redirect to={`/${kingdomId}`} />
                }
            default:
                return <Redirect to={`/${kingdomId}`} />
        }
    }

    render() {
        const { error, networkError, match, intl } = this.props
        const EXCEPTION_CATEGORY = intl.formatMessage({
            id: 'routes.kingdom.orders'
        })
        const menuItems = this.state.menuItems.filter(m => m.inMenu)
        const children = this.getChildElement(match.params.kingdomId)
        const background =
            match.params.kingdomId === EXCEPTION_CATEGORY
                ? 'white'
                : 'transparent'

        return (
            <ErrorManagement error={error} networkError={networkError}>
                <Layout border background="plain">
                    <FireBackground>
                        <MenuLayout
                            background={background}
                            menuItems={menuItems}
                            route="routes.kingdom.dashboard"
                            menuTitle="kingdom.dashboard.menuTitle"
                            menuBackgroundImage>
                            {children}
                        </MenuLayout>
                    </FireBackground>
                </Layout>
            </ErrorManagement>
        )
    }
}

const KingdomComponent = injectIntl(Kingdom)

export { KingdomComponent }
